export class GTMTriggers {
    static PURCHASE_SUCCESS = 'purchase_success';
    static PURCHASE_SUMMARY = 'purchase_summary';
    static ACCOUNT_CREATED = 'account_created';
}

Object.freeze(GTMTriggers);